// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/taf-decode.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/taf-decode/taf-decode.js';

mount([g0]);
